<template>
  <div
    class="login_box"
    v-loading="loading"
    element-loading-text="登录中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.8)"
  >
    <div class="login_bg"></div>
    <div class="login_form">
      <div class="logo">
        <img
          src="https://univteam-imageserver.oss-cn-qingdao.aliyuncs.com/ClassMS/Images/202111021516022056.png"
          alt=""
        />
      </div>
      <div class="form_box">
        <el-tabs v-model="activeName">
          <el-tab-pane label="免密登录" name="first">
            <div class="form_phone">
              <el-input
                v-model="phone"
                placeholder="手机号"
                maxlength="11"
                type="number"
              ></el-input>
              <div class="sms-box">
                <el-input
                  v-model="sms"
                  placeholder="短信验证码"
                  maxlength="6"
                ></el-input>
                <div class="getSms" @click="getSms" v-show="!timeShow">
                  获取验证码
                </div>
                <div class="getSms" v-show="timeShow" style="cursor: inherit">
                  {{ time }}s后可重新获取
                </div>
              </div>
              <!-- <div class="register">注册</div> -->
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="密码登录" name="second">
            <div class="form_phone">
              <el-input
                v-model="phone"
                placeholder="手机号"
                type="number"
              ></el-input>
              <div style="margin-top: 30px">
                <el-input v-model="phone" placeholder="密码"></el-input>
              </div>
            </div>
            <div class="register forget">忘记密码？</div>
          </el-tab-pane> -->
        </el-tabs>
        <div class="loginIn" @click="getToken">登录</div>
      </div>
      <div class="copyright">
        <span>© 2016 - 2025 北京高校思想政治理论课高精尖创新中心</span
        >&nbsp;&nbsp;|&nbsp;&nbsp; <span>京ICP备10054422号-13</span
        ><span @click="dialogVisible = true">联系我们</span>
        <span class="dataShow" @click="onDataShow">数据可视化平台</span>
      </div>
    </div>
    <!-- 联系我们 -->
    <div class="callMe">
      <el-dialog title="联系我们" :visible.sync="dialogVisible" width="400px">
        <div class="callMe_box">
          <!-- <div>
            <img
              src="https://oss2.iouke.cn/growth_log/imgbg/2021/8/19/c6d7e2bc3612a90098b661b867ea588b.jpg"
              alt=""
            />
            <p>扫描二维码</p>
            <p>添加助理张老师</p>
          </div> -->
          <div>
            <img src="../assets/phone.png" alt="" />
            <p>电话：010-82825072</p>
            <!-- <p class="p3"></p> -->
            <p>手机号：13722799807</p>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 选择学校 -->
    <div class="callMe callSchool">
      <el-dialog title="请输入学校" :visible.sync="schoolDialog" width="800px" @close="closeSchoolmodal">

        <div class="detail">
          <div class="detailRight">
            <input
              type="text"
              value=""
              placeholder="学校名称"
              @input="writeSchool"
              v-model="schoolValue"
            />
            <ul class="university schoolBox2" v-if="showUniversity">
              <li
                v-for="(item, index) in UniversityArr"
                :key="item.id"
                @click="universityItem(index + 1, item.id, item)"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="click_true" @click="determine">确定</div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "first",
      phone: "",
      sms: "",
      dialogVisible: false,
      schoolDialog: false,
      radio: 3,
      smsId: "",
      time: 60,
      token: "",
      university: "",
      timer: null,
      loading: false,
      timeShow: false,
      showUniversity: false,
      UniversityArr: [],
      schoolValue: "", //你的学校
      showSpecialty: true,
      universityId:0,
      timerThrottle:null,
      identityType:-1,
    };
  },
  mounted() {
    
  },
  methods: {
    onDataShow(){
      // window.location.href="http://zs.sjyr.bjcipt.com"
      window.location.href="http://pt.sjyr.bjcipt.com/#/showMain"
    },
    closeSchoolmodal(){
      this.loading = false;
    },
      // 输入你的学校
    writeSchool() {
      var _this = this;
      if (this.schoolValue !== "") {
        this.fnThrottle(this.getUniversity, 500, 500)();

        this.showUniversity = true;
        this.showSpecialty = false;
        this.radius = true;
      } else {
        this.showUniversity = false;
        this.showSpecialty = true;
        this.radius = false;
      }
    },
    // 节流
    fnThrottle(method, delay, duration) {
      var that = this;
      var timerThrottle = this.timerThrottle;
      var begin = new Date().getTime();
      return function () {
        var context = that;
        var args = arguments;
        var current = new Date().getTime();
        clearTimeout(timerThrottle);
        if (current - begin >= duration) {
          method.apply(context, args);
          begin = current;
        } else {
          that.timerThrottle = setTimeout(function () {
            method.apply(context, args);
          }, delay);
        }
      };
    },
    //根据关键词获取大学名称列表
    getUniversity() {
      let key = this.schoolValue;
      let params = {
        ppcId: 11,
        key:key,
      };

      this.$api.common
        .getUniversityList(params)
        .then((res) => {
          this.UniversityArr = res.data;
          if (this.UniversityArr.length == 0) {
            this.showUniversity = false;
            this.showSpecialty = true;
            this.radius = false;
          }
        })
        .catch((err) => {});
    },
    universityItem(index, id, item) {
      console.log(item);
      this.number = index;
      this.schoolValue = item.name;
      this.universityId = item.id;
      this.logoUri = item.logoUri;
      this.showUniversity = false;
      this.showSpecialty = true;
      this.radius = false;
      localStorage.setItem("school_id", item.id);
    },
    //获取验证码
    getSms() {
      let _this = this;
      clearInterval(this.timer);
      if (this.phone == "") {
        this.$message.error("请填写手机号！");
        return;
      }
      if (!/^1[345789]\d{9}$/.test(_this.phone)) {
        _this.$message.error("手机号码有误，请重填");
        return;
      }
      this.time = 60;
      this.timer = null;
      this.timeShow = true;
      this.timer = setInterval(function () {
        _this.time--;
        if (_this.time <= 0) {
          clearInterval(_this.timer);
          _this.time = 60;
          _this.timeShow = false;
        }
      }, 1000);
      this.$api.common.getSMS(this.phone).then((res) => {
        if (res.data.statusCode == 200) {
          this.identityType=res.data.data.type;
          this.smsId = res.data.data.smsId;
          if (!res.data.data) {
            _this.$message.error("获取过于频繁，请稍候获取");
            clearInterval(this.timer);
            _this.time = 60;
            _this.timeShow = false;
          }
        } else {
          _this.$message.error(res.data.msg);
          clearInterval(this.timer);
          _this.time = 60;
          _this.timeShow = false;
        }
      });
    },
    // 确定提交学校
    determine(){
      if(this.universityId == 0 ){
        this.$alert("请选择学校");
      }else{
        this.schoolDialog=false;
        let params = {
          mobile: this.phone,
          smsid: this.smsId,
          validatecode: this.sms,
          universityId:this.universityId,
        };
          console.log(params)
          this.$api.common.getToken(params).then((res) => {
            if (res.data.statusCode == 200) {
              localStorage.setItem("user_token", res.data.data.token);
              localStorage.setItem("university", res.data.data.university);
              localStorage.setItem("name", res.data.data.name);
              localStorage.setItem("avatarUri", res.data.data.avatarUri);
              clearInterval(this.timer);
              this.$router.push("/");
            } else {
              this.$notify.error({
                title: res.data.errors,
                message: res.data.errors,
              });
            }
            this.loading = false;
          });
      }
    },
    //登陆
    getToken() {
      if (this.phone == "") {
        this.$message.error("请填写正确手机号！");
        return;
      }
      if (this.sms == "") {
        this.$message.error("请填写验证码！");
        return;
      }
      this.loading = true;
      if(this.identityType == 0){
        this.schoolDialog = true;
      }else{
      let params = {
        mobile: this.phone,
        smsid: this.smsId,
        validatecode: this.sms,
        universityId:0,
      };
        console.log(params)
        this.$api.common.getToken(params).then((res) => {
          if (res.data.statusCode == 200) {
            localStorage.setItem("user_token", res.data.data.token);
            localStorage.setItem("university", res.data.data.university);
            localStorage.setItem("name", res.data.data.name);
            localStorage.setItem("avatarUri", res.data.data.avatarUri);
            clearInterval(this.timer);
            this.$router.push("/");

          } else {
            this.$notify.error({
              title: res.data.errors,
              message: res.data.errors,
            });
          }
          this.loading = false;
        });
      }
      

    },
  },
};
</script>
<style lang="scss" scoped>
.login_box {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
}
.login_bg {
  background: url("https://univteam-imageserver.oss-cn-qingdao.aliyuncs.com/ClassMS/Images/202111021514388334.png") no-repeat center;
  background-size: 100% 100%;
  height: 100%;
  width: 50%;
}
.login_form {
  position: relative;
  width: 50%;
  height: 100%;
  .logo {
    width: 100%;
    height: 81px;
    text-align: center;
    margin-top: 139px;
    margin-bottom: 70px;
    img {
      width: 450px;
    }
  }
  .form_box {
    position: relative;
    width: 572px;
    height: 500px;
    border-radius: 20px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.06);
    margin: 0 auto;
    margin-top: 50px;
    padding: 50px;
    ::v-deep .is-active {
      background-image: inherit !important;
    }
    ::v-deep .el-tabs__nav-wrap::after {
      height: 0;
    }
    ::v-deep .el-tabs__item {
      font-size: 20px;
      line-height: 20px;
    }
    ::v-deep .el-tabs__active-bar {
      width: 60px !important;
      height: 4px;
      border-radius: 2px;
      background: #007F41;
      left: 10px;
    }
    ::v-deep .el-tabs__item:hover {
      color: #2a2e3d;
    }
    ::v-deep .el-tabs__item.is-active {
      color: #2a2e3d;
    }
    ::v-deep .el-tabs__header {
      margin-bottom: 0;
    }
    .form_phone {
      margin-top: 50px;
      ::v-deep .el-input__inner {
        height: 60px;
        border: 0.5px solid #bac2d1;
        border-radius: 8px;
        font-size: 18px;
        color: #2a2e3d;
        &::placeholder {
          color: #7c829d;
        }
        &::-webkit-input-placeholder {
          /* WebKit browsers 适配谷歌 */
          color: #7c829d;
        }
        &:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 适配火狐 */
          color: #7c829d;
        }
        &::-moz-placeholder {
          /* Mozilla Firefox 19+ 适配火狐 */
          color: #7c829d;
        }
        &:-ms-input-placeholder {
          /* Internet Explorer 10+  适配ie*/
          color: #7c829d;
        }
      }
      .sms-box {
        margin-top: 30px;
        position: relative;
        display: flex;
        align-items: center;
        .getSms {
          font-size: 18px;
          color: #007F41;
          position: absolute;
          z-index: 10;
          right: 15px;
          cursor: pointer;
        }
      }
    }
    .register {
      color: #007F41;
      font-size: 18px;
      margin-top: 20px;
      margin-left: 20px;
      cursor: pointer;
      text-align: left;
      //   line-height: 18px;
    }
  }
  .loginIn {
    width: 100%;
    height: 60px;
    border-radius: 8px;
    color: #fff;
    background: #007F41;
    text-align: center;
    line-height: 60px;
    font-size: 20px;
    margin-top: 50px;
    cursor: pointer;
  }
  .forget {
    color: #7c829d !important;
    text-align: right !important;
    margin-right: 20px;
  }
}
.copyright {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 30px;
  color: #bac2d1;
  font-size: 14px;
  line-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 50;
  span:nth-child(3) {
    cursor: pointer;
    width: 75px;
    height: 24px;
    background: rgba(0, 127, 65, 0.09);
    color: #007f41;
    line-height: 24px;
    border-radius: 4px;
    margin-left: 52px;
  }
}
.callMe {
  ::v-deep .el-dialog {
    border-radius: 20px;
  }
  ::v-deep .el-dialog__close {
    width: 16px;
    height: 16px;
    color: #bac2d1;
    font-size: 20px;
  }
  ::v-deep .el-dialog__title {
    color: #2a2e3d;
    font-size: 24px;
  }
  ::v-deep .el-dialog__header {
    text-align: center;
    padding-top: 30px;
  }
  ::v-deep .el-dialog__body {
    padding-top: 50px;
    padding-bottom: 70px;
  }
  ::v-deep .el-dialog {
    margin-top: 30vh !important;
  }
  .school_list {
    padding: 20px 30px;
    height: 279px;
    overflow-y: auto;
    position: relative;
    padding-bottom: 60px;
    width: calc(100% - 5px);
    li {
      height: 40px;
      width: 100%;
      margin-bottom: 15px;
      img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
    }
    ::v-deep.el-radio {
      display: flex;
      align-items: center;
    }
    ::v-deep.el-radio__label {
      display: flex;
      align-items: center;
    }
    ::v-deep .el-radio__inner {
      width: 20px;
      height: 20px;
    }
    ::v-deep .el-radio__input.is-checked .el-radio__inner {
      border-color: #007F41;
      background-color: #fff;
    }
    ::v-deep .el-radio__inner::after {
      background-color: #007F41;
      width: 12px;
      height: 12px;
    }
    ::v-deep.el-radio__label {
      padding-left: 15px;
      font-size: 18px;
      color: #7c829d;
    }
  }
  .click_true {
    background: #007F41;
    color: #fff;
    font-size: 22px;
    width: 100px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 8px;
    cursor: pointer;
    position: absolute;
    bottom: 20px;
    left: 50%;
    margin-left: -50px;
  }
}
.callMe_box {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #7c829d;
  line-height: 22px;
  div {
    // width: 50%;
    width: 100%;
    text-align: center;
    height: 178px;
  }
  div:nth-child(1) {
    // border-right: 1px dashed #bac2d1;
    img {
      width: 100px;
      height: 100px;
      margin-bottom: 5px;
    }
    p{
       line-height: 40px;
       font-size: 20px;
    }
    p:nth-child(2){
      margin-top: 10px;
    }
  }
  div:nth-child(2) {
    line-height: 30px;
    img {
      margin-top: 27px;
      margin-bottom: 20px;
    }
    .p3 {
      font-size: 18px;
      color: #2a2e3d;
    }
  }
}
.callSchool {
  position: relative;
  ::v-deep.el-dialog__body {
    padding: 0;
    height: 400px;
  }
.detail {
    width: 95%;
    height: 43px;
    background: #fff;
    border-radius: 100px;
    margin-top: 30px;
    display: flex;
    flex-flow: wrap;
    box-shadow: rgba(27, 181, 193, 0.2) 0px 4px 20px;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    margin: 0 auto;
    margin-top: 5px;
    img {
      width: 20px;
      height: 20px;
      margin-top: 10px;
      box-shadow: rgba(27, 181, 193, 0.2) 0px 0px 20px;
      text-align: center;
      line-height: 43px;
      font-size: 20px;
    }

    .detailRight {
      // flex: auto;
      width: 100%;
      font-size: 15px;

      input {
        border: 1px solid #fff;
        outline: none;
        font-weight: 700;
        margin-left: 12px;
        overflow: hidden;
        width: 95%;
        padding: 10px 10px;
      }
    }
    .login {
      flex: auto;
      width: 31px;
      height: 31px;
      border-radius: 100px;
      margin-right: 5px;
      margin-top: 0;
    }
  }
}
.school_list::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.school_list::-webkit-scrollbar-track {
  -webkit-box-shadow: inherit;
  border-radius: 0;
  background: inherit;
}
.school_list::-webkit-scrollbar-thumb {
  border-radius: inherit;
  -webkit-box-shadow: inherit;
  background: #bac2d1;
}
::v-deep .el-input__inner::-webkit-outer-spin-button,
::v-deep .el-input__inner::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.dataShow {
  background: rgba(0, 127, 65, 0.09);
  color: #007f41;
  line-height: 24px;
  border-radius: 4px;
  margin-left: 10px;
  cursor: pointer;
  height: 24px;
  padding:0 5px;
}
.university {
  height: 250px;
  overflow: auto;
  background: #fff;
  position: absolute;
  width: 95%;
  margin-top: 0.15rem;
  z-index: 99;
  border-radius: 10px;
  box-shadow: rgba(27, 181, 193, 0.2) 0px 4px 20px;
}
.university li {
  font-size: 15px;
  color: #727b8c;
  border-bottom: 1px #e8e8e8 dashed;
  padding: 10px;
  width: 90%;
  margin-left: 5%;
}
</style>